import React, { MouseEvent, useRef } from "react";
import cn from "classnames";
import { SpriteIcon } from "components/UI/SpriteIcon";
import closeIcon from "public/img/icons/close-alt.svg";
import closePopupIcon from "public/img/icons/close-popup.svg";
import styles from "./Modal.module.scss";
import { Button } from "components/UI/buttons/Button";
import { upperFirst } from "lodash";

export type ModalProps = {
  children: React.ReactNode;
  open: boolean;
  type?: "regular" | "formatPreview" | "idlePopup" | "downloadSample";
  setOpen: (open: boolean) => void;
  onClick?: () => void;
};

export const Modal = ({ children, open, setOpen, type = "regular", onClick }: ModalProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  const onOverlayClick = (event: React.MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest("." + styles.modal)) setOpen(false);
    onClick?.();
  };

  return open ? (
    <div className={styles.overlay} ref={overlayRef} onClick={onOverlayClick}>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <div className={cn(styles.modal, styles[`modalType${upperFirst(type)}`])}>
            {children}
            <Button tag="button" type="secondary" className={styles.closeBtn} onClick={() => setOpen(false)}>
              <SpriteIcon
                icon={["idlePopup", "downloadSampleResult"].includes(type) ? closePopupIcon : closeIcon}
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
